import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { UserManagementType } from '@/types/user-management';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type UserManagementState = {
  data: UserManagementType[];
  pagination: PaginationAPI;
  totalElements?: number;
  loading: boolean;
};

export const userManagementInitialState: UserManagementState = {
  data: [],
  pagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  loading: false,
};

const slice = createSlice({
  name: 'userManagement',
  initialState: userManagementInitialState,
  reducers: {
    setListUserManagementAction(
      state,
      action: PayloadAction<{
        data: UserManagementType[];
        pagination?: PaginationAPI;
        totalExtend?: number;
      }>,
    ) {
      const { payload } = action;
      state.data = payload.data;

      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    addUserManagementAction(state, { payload }: PayloadAction<UserManagementType>) {
      state.data = [payload, ...state.data];
      state.pagination = {
        ...state.pagination,
        Page: state.pagination.Page + 1,
        totalElements: state.pagination.totalElements + 1,
      };
    },

    updateUserManagementAction(state, { payload }: PayloadAction<UserManagementType>) {
      state.data = state.data.map((item) => {
        if (item.id === payload.id) {
          return payload;
        }
        return item;
      });
    },
  },
});

export const { setListUserManagementAction, addUserManagementAction, updateUserManagementAction } =
  slice.actions;
export default slice.reducer;
